// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag'
import { buttonFields } from '../elements/buttonFragment.graphql'
import { imageFields } from '../elements/imageFragment.graphql'

export const sectionHomepageHeroFields = gql`
  fragment sectionHomepageHeroFields on SectionHomepageHeroRecord {
    subtitle
    title
    image {
      ...imageFields
    }
    actions {
      ...buttonFields
    }
  }
  ${buttonFields}
  ${imageFields}
`
